// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__3BNlI"};